import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const MaxRentalTime: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('right'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='max-rental-time'
        propertyName='maxRentalTime'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.maxRentalTime', 'Max Rental Time')}</span>}
        value={insertionData.maxRentalTime}
        maxLength={3}
        type='text'
        numericOnly
        affixRight='icon'
        iconRight={
          <span className={'font-body-large-regular'}>{t('wizard.screen.otherFacilities.placeholder.months')}</span>
        }
        errors={validationMessages!.maxRentalTime ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MaxRentalTime
